import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Col, Row, Spinner } from 'reactstrap';
import * as GenModels from "../../models/GenericModels";

type load_status = { loading: boolean, title?: string, address?: GenModels.Address }

//export class LoadingIcon extends React.PureComponent<load_status> {

//    /*static history = useHistory();*/
    
//    handleClick () {      
//        /*history.goBack();*/
//    };       
 
//    public render() {
//        return (
//            <div style={{ height: '25px' }}>
//                <Col><Row>
//                    <div style={{ padding: "5px" }} onClick={this.handleClick}>
//                        <FontAwesomeIcon icon={faArrowCircleLeft} />
//                     </div>
//                    </Row>
//                    <Row>
//                        <div style={{ display: this.props.loading ? 'block' : 'none', paddingTop: '5px', paddingRight: '5px', textAlign: 'right' }} >
//                            Loading <Spinner size="sm" color="primary" />
//                        </div>
//                    </Row>
//                </Col>
//            </div>
//        );
//    }
//}

//const history = useHistory();

export function LoadingIcon(props: load_status) {

    const history = useHistory();

    function handleClick() {
        history.goBack();
    };

    return (
        <div>
            <Row style={{ border: "1px solid gray", padding: "5px" }}>
                <Col xs="2">                    
                    <div style={{ paddingTop: "4px", cursor: "pointer" }} onClick={handleClick}>
                        <FontAwesomeIcon icon={faArrowCircleLeft} className="miscBackIcon" />                        
                    </div>                  
                </Col>
                <Col xs="8" className="center-align" style={{ paddingLeft: "0px", paddingRight: "0px", paddingTop: '6px' ,fontSize: "1.1em" }}>                    
                    {props.title} <br />
                    {props.address &&
                        <span style={{ fontSize: "0.7em" }} >{props.address.line1} <br/> {props.address.city}, {props.address.state} {props.address.zip} </span>
                    }
                </Col>
                <Col xs="2">
                    <div style={{ display: props.loading ? 'block' : 'none', paddingTop: '4px',  margin:'0px',  textAlign: 'right' }} >
                        <Spinner size="sm" color="primary" />
                    </div>
                </Col>
            </Row>
        </div>
    );

}


 